import React from 'react'
import {BrowserRouter as Router, Routes, Route} from 'react-router-dom'

import Home from "./Home";
import About from "./About";
import News from "./News";
import Contact from "./Contact";
import NewsDetails from "./news-details";
import Faq from "./faq";
import History from "./history";
import Price from "./price";
import CaseDetails from './case-details';
import Team from './team';
import TeamDetails from './team-details';
import Services from './services';
import ServiceDetails from './services-details';
import HomeTwo from './home-2';
import HomeThree from './home-3';
import HomeFour from './home-4';
import HomeFive from './home-5';
import Portfolio from './portfolio';
import OnePageOne from './onepage-1';
import OnePageTwo from './onepage-2';
import OnePageThree from './onepage-3';

export default function RouterPage() {
  return (
    <div>
        <Router>
            <Routes>               
                <Route path="/" element={<Home />}></Route>
                <Route path="/home-2" element={<HomeTwo />}></Route>
                <Route path="/home-3" element={<HomeThree />}></Route>
                <Route path="/home-4" element={<HomeFour />}></Route>                
                <Route path="/home-5" element={<HomeFive />}></Route>     
                <Route path="/onepage-1" element={<OnePageOne />}></Route>             
                <Route path="/onepage-2" element={<OnePageTwo />}></Route>  
                <Route path="/onepage-3" element={<OnePageThree />}></Route>                          
                <Route path="/About" element={<About />}></Route>   
                <Route path="/Contact" element={<Contact />}></Route>    
                <Route path="/News" element={<News />}></Route>                    
                <Route path="/news-details"   element={<NewsDetails />}></Route>                    
                <Route path="/faq" element={<Faq />}></Route>
                <Route path="/history" element={<History />}></Route>                    
                <Route path="/price" element={<Price />}></Route>   
                <Route path="/case-details" element={<CaseDetails />}></Route>      
                <Route path="/team" element={<Team/>}></Route>              
                <Route path="/team-details" element={<TeamDetails/>}></Route>              
                <Route path="/services" element={<Services/>}></Route>              
                <Route path="/services-details" element={<ServiceDetails/>}></Route>              
                <Route path="/portfolio" element={<Portfolio/>}></Route>              
            </Routes>
        </Router>
    </div>
  )
}
